// Elements declared in index.html, looked up once.
export const bBack = document.getElementById('bBack');
export const bFull = document.getElementById('bFull');
export const bDay = document.getElementById('bDay');
export const bLang = document.getElementById('bLang');
export const bNight = document.getElementById('bNight');
export const bReset = document.getElementById('bReset');
export const bTraffic = document.getElementById('bTraffic');
export const chapters = document.getElementById('chapters');
export const go = document.getElementById('go');
export const hint = document.getElementById('hint');
export const introSub = document.getElementById('introSub');
export const panel = document.getElementById('panel');
export const speed = document.getElementById('speed');
export const tBoost = document.getElementById('tBoost');
export const tBrake = document.getElementById('tBrake');
